import { CONFIG_WIN_POINTS_MESSAGE } from "../constants/game"
import { assetsImageLoader } from "../utils/funtions"

export default function WinPointsMessageComponent(context) {

    this.container = null;
    this.context = context;
    const game = context.game;
    const getGameSize = () => game.scale.gameSize;
    const tweensConfig = {
        fadeIn: {
            targets: [this.container],
            duration: 800, 
            visible: true,
            alpha:1,
            scale:1,
            ease: 'Elastic',
            easeParams: [0.4, 0.5],
            onStart:()=>{
                this.container.setAlpha(0);
                this.container.setScale(0);
            },
            onComplete: () => {
                popOut();
            }
        },
        fadeOut: {
            targets: [this.container],
            duration: 1500,
            y: 20, 
            alpha: 0,  
            ease: 'Elastic',
            easeParams: [0.4, 0.5],
            onComplete: () => {
               
               this.container.setVisible(false)
            }
        }
    } 
    this.preload = () => {
        const assetsToLoad = {
            'background': CONFIG_WIN_POINTS_MESSAGE.src,
        }

        assetsImageLoader(
            assetsToLoad,
            'winpointsmessage-',
            context
        )
    }

    this.create = () => {

        this.container = context.add.container(0, 0, []).setDepth(CONFIG_WIN_POINTS_MESSAGE.depth);

        this.backgroundImg = context.add
            .image(
                0,
                0,
                `winpointsmessage-background`
            )
            .setOrigin(0, .5).setScrollFactor(0).setDepth(1);




        this.pretext = context.add
            .text(
                CONFIG_WIN_POINTS_MESSAGE.padding_start, 0,
                CONFIG_WIN_POINTS_MESSAGE.pretext.text,
                CONFIG_WIN_POINTS_MESSAGE.pretext.style
            )
            .setResolution(2)
            .setDepth(2)
            .setScrollFactor(0)
            .setOrigin(0, 0.5);

        this.pointstext = context.add
            .text(
                this.pretext.x + this.pretext.width + CONFIG_WIN_POINTS_MESSAGE.wordsSpacing, 0,
                CONFIG_WIN_POINTS_MESSAGE.pointstext.text(0),
                CONFIG_WIN_POINTS_MESSAGE.pointstext.style
            )
            .setResolution(2)
            .setDepth(2)
            .setScrollFactor(0)
            .setOrigin(0, 0.5);


        this.container.add([this.backgroundImg, this.pretext, this.pointstext]);
        this.container.setSize(this.backgroundImg.width, this.backgroundImg.height)
        this.container.setVisible(false);
        tweensConfig.fadeIn.targets = tweensConfig.fadeOut.targets = this.container;
        // CENTER
        center();
    };

    const center = () => {
        this.container.x = getGameSize().width / 2 - this.container.width / 2;
        this.container.y = getGameSize().height;//- this.container.height / 2
    };

    const popUp = () => {
        center();
        this.container.setVisible(true);
        this.container.setAlpha(0);
        tweensConfig.fadeIn.y = getGameSize().height / 2 - this.container.height / 2
        context.tweens.add(tweensConfig.fadeIn);
    }
    const popOut = () => {
        setTimeout(() => {
            context.tweens.add(tweensConfig.fadeOut);
        }, 1000)
    };
    context.data.events.on('changedata',
        (gameObject, dataKey, newValue, prevValue) => {
            if (dataKey === "POINTS") {
                this.pointstext.setText(CONFIG_WIN_POINTS_MESSAGE.pointstext.text(newValue-prevValue));
                popUp();
            }
        });

}